/******************************************************************************
   NAME:       CAYTHUMUC
   AUTHOR:     Duynh

   1. Load danh sách trạm ban đầu
   2. Mỗi lần Expand truy vấn với parameter là id -> có dữ liệu gán vào đúng vị trí -> xóa Loading...
   3. Mỗi lần chọn 1 thư mục, gửi lệnh tới service đang theo dõi sự kiện tại danhmucservice 

******************************************************************************/

import { Component, ViewChild, AfterViewInit, ViewEncapsulation, AfterContentInit, Output, EventEmitter, OnInit, NO_ERRORS_SCHEMA, Input, OnDestroy } from '@angular/core';
import { DanhMucService, UserService } from '../../services/index';
import { Subscription } from 'rxjs/Subscription';

import { myJqxTreeItem } from '../../model/tree';
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs/Observable';
import { TreeNode } from 'primeng/api';
// import { TreeNode } from '@angular/router/src/utils/tree';


@Component({
  selector: 'app-caythumuc-new',
  templateUrl: './caythumuc.component.html',
  styleUrls: ['./caythumuc.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: []

})


export class CayThuMucNewComponent implements AfterViewInit, AfterContentInit, OnDestroy {
  lstDanhMucRoot: TreeNode[];
  tempNode: TreeNode;
  selectedFiles: TreeNode;

  private lst_danhmuc: any[];
  public dltong: string;

  IsLoadingChild: boolean = true;
  //bien su kien reload
  subscription: Subscription;

  constructor(
    private DanhMucService: DanhMucService,
    private user: UserService,
  ) {
    this.subscription = this.DanhMucService.reloadNav$.subscribe(
      item => {
        let user = this.user.getCurrentUser();
        this.getAllTram(user.danhmucid);
      });
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      let user = this.user.getCurrentUser();
      this.getAllTram(user.danhmucid);
    });
  }

  public ngAfterContentInit(): void {
    let currentUser = this.user.getCurrentUser();
    this.dltong = currentUser.tendanhmuc;
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  private getAllTram(danhmucid: any) {

    let selectedDirectory = JSON.parse(sessionStorage.getItem("selectedDirectory"));
    this.lstDanhMucRoot = [];
    let user = this.user.getCurrentUser();
    this.DanhMucService.getDanhmuc(danhmucid, "TOP", user.mataikhoan, 1).subscribe(response => {
      let listTram: any = response;
      let lstDanhMucChild: any = [];
      if (listTram.data.length > 0) {
        //nếu có tổng công ty
        let index = listTram.data.findIndex(x => x.danhmucid == 0);
        if (index >= 0) {
          let node: TreeNode = {
            label: listTram.data[index].tendanhmuc,
            data: listTram.data[index].danhmucid,
            loaidanhmuctext: listTram.data[index].loaidanhmuc,
            loaidanhmuc: listTram.data[index].loaidanhmuc,
            meterid: listTram.data[index].meterid,
            code: listTram.data[index].code,
            isLoaded: true,
            expanded: true,
            leaf: false,
            styleClass: (listTram.data[index].danhmucid == selectedDirectory.value) ? "selected-item" : "",

          }
          listTram.data.forEach((item, index) => {
            if (item.danhmuccha == node.data) {
              let node: TreeNode = {
                label: item.tendanhmuc,
                data: item.danhmucid,
                loaidanhmuctext: item.loaidanhmuc,
                loaidanhmuc: item.loaidanhmuc,
                meterid: item.meterid,
                code: item.code,
                children: [],
                isLoaded: false,
                expanded: false,
                leaf: false,
                styleClass: (item.danhmucid == selectedDirectory.value) ? "selected-item" : ""
              }
              if (item.danhmucid == selectedDirectory.value) {
                this.tempNode = node;
                this.selectedFiles = node;
              }

              lstDanhMucChild.push(node);
            }
          });
          node.children = lstDanhMucChild;
          this.lstDanhMucRoot.push(node);
        }
        else {
          let index = listTram.data.findIndex(x => x.danhmuccha == 0);
          if (index >= 0) {
            let node: TreeNode = {
              label: listTram.data[index].tendanhmuc,
              data: listTram.data[index].danhmucid,
              loaidanhmuc: listTram.data[index].loaidanhmuc,
              meterid: listTram.data[index].meterid,
              code: listTram.data[index].code,
              isLoaded: true,
              expanded: true,
              loaidanhmuctext: listTram.data[index].loaidanhmuc,
              leaf: false
            }

            listTram.data.forEach((item, index) => {
              if (item.danhmuccha == node.data) {
                let node: TreeNode = {
                  label: item.tendanhmuc,
                  data: item.danhmucid,
                  children: [],
                  loaidanhmuctext: item.loaidanhmuc,
                  loaidanhmuc: item.loaidanhmuc,
                  meterid: item.meterid,
                  code: item.code,
                  isLoaded: false,
                  expanded: false,
                  leaf: false,
                  styleClass: (listTram.data[index].danhmucid == selectedDirectory.value) ? "selected-item" : ""
                }
                if (item.danhmucid == selectedDirectory.value) {
                  this.tempNode = node;
                  this.selectedFiles = node;
                }
                lstDanhMucChild.push(node);
              }
            });
            node.children = lstDanhMucChild;
            this.lstDanhMucRoot.push(node);
          }
          else {
            let index = listTram.data.findIndex(x => x.danhmucid == danhmucid);
            if (index >= 0) {
              let node: TreeNode = {
                label: listTram.data[index].tendanhmuc,
                data: listTram.data[index].danhmucid,
                loaidanhmuc: listTram.data[index].loaidanhmuc,
                meterid: listTram.data[index].meterid,
                code: listTram.data[index].code,
                isLoaded: true,
                expanded: true,
                loaidanhmuctext: listTram.data[index].loaidanhmuc,
                leaf: false,
                styleClass: (listTram.data[index].danhmucid == selectedDirectory.value) ? "selected-item" : ""
              }

              listTram.data.forEach((item, index) => {
                if (item.danhmuccha == node.data) {
                  let node: TreeNode = {
                    label: item.tendanhmuc,
                    data: item.danhmucid,
                    children: [],
                    loaidanhmuctext: item.loaidanhmuc,
                    loaidanhmuc: item.loaidanhmuc,
                    meterid: item.meterid,
                    code: item.code,
                    isLoaded: false,
                    expanded: false,
                    leaf: false,
                    styleClass: (item.danhmucid == selectedDirectory.value) ? "selected-item" : ""
                  }
                  if (item.danhmucid == selectedDirectory.value) {
                    this.tempNode = node;
                    this.selectedFiles = node;
                  }
                  lstDanhMucChild.push(node);
                }
              });
              node.children = lstDanhMucChild;
              this.lstDanhMucRoot.push(node);
            }
          }
        }
      }
      else {
        let node: TreeNode = {
          label: "Tài khoản chưa được phân quyền, vui lòng liên hệ người quản trị",
          data: null,
          children: [],
          isLoaded: false,
          expanded: true,
          leaf: false
        }

        this.lstDanhMucRoot.push(node);
        let jqxitem = new myJqxTreeItem(
          this.lstDanhMucRoot[0].label,
          this.lstDanhMucRoot[0].data,
          this.lstDanhMucRoot[0].loaidanhmuctext,
          "mainTree",
          this.lstDanhMucRoot[0].meterid,
          this.lstDanhMucRoot[0].tendanhmuc,
          this.lstDanhMucRoot[0].code
        )
        sessionStorage.setItem(environment.SESSION_DANHMUC_NAME, JSON.stringify(jqxitem));
      }
      this.IsLoadingChild = false;
    });

  }
  nodeSelect(event) {

    if (this.tempNode != undefined) {
      this.tempNode.styleClass = "";
    }

    event.node.styleClass = "selected-item";
    this.tempNode = event.node;
    let jqxitem = new myJqxTreeItem(event.node.label, event.node.data, event.node.loaidanhmuc, "mainTree", event.node.meterid, event.node.tendanhmuc, event.node.code);
    sessionStorage.setItem(environment.SESSION_DANHMUC_NAME, JSON.stringify(jqxitem));
    this.DanhMucService.changeNav(jqxitem);
    // if (event.node.loaidanhmuc > 2) {


    sessionStorage.removeItem(environment.DsKhachHang);
    let user = this.user.getCurrentUser();
    this.DanhMucService.getKhachHangByDanhMucID(event.node.data, user.mataikhoan).subscribe(res => {
      let ret = res;
      if (ret.data.length > 0) {
        sessionStorage.setItem(environment.DsKhachHang, JSON.stringify(ret.data));
      }
      else {
        sessionStorage.setItem(environment.DsKhachHang, "");
      }
      this.DanhMucService.loadCusDone();
    });
    // }
    // else {
    //   this.DanhMucService.loadCusDone();
    // }
  }

  nodeExpand(event) {

    if (!event.node.isLoaded) {
      let user = this.user.getCurrentUser();
      event.node.isLoaded = true;
      this.IsLoadingChild = true;
      this.DanhMucService.getDanhmuc(event.node.data, "child", user.mataikhoan, 1).subscribe(response => {
        let listTram: any = response;
        if (listTram.data.length <= 0) {
          event.node.leaf = true;
          event.node.expanded = false;
          event.node.icon = '';
          event.node.styleClass = "";
        }
        else {
          listTram.data.forEach(element => {
            if (element.meterid == 0) {
              let node: TreeNode = {
                label: element.tendanhmuc,
                data: element.danhmucid,
                loaidanhmuc: element.loaidanhmuc,
                loaidanhmuctext: element.loaidanhmuc,
                meterid: element.meterid,
                code: element.code,
                children: [],

                isLoaded: false,
                expanded: false,
                leaf: false,
                styleClass: ""

              }
              event.node.children.push(node);
              event.node.expanded = true;
            } else {
              let node: TreeNode = {
                label: element.tendanhmuc,
                data: element.danhmucid,
                loaidanhmuc: element.loaidanhmuc,
                loaidanhmuctext: element.loaidanhmuc,
                meterid: element.meterid,
                code: element.code,
                children: [],

                isLoaded: true,
                expanded: true,
                leaf: true,
                styleClass: "",
                icon: element.ketnoi,


              }
              event.node.children.push(node);
            }
          });

        }
        this.IsLoadingChild = false;
      });
    }
  }
}





// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/share/cay-thu-muc-new/caythumuc.component.ts